import React from 'lib/react';
import {
  EVPaper, EVGrid,
} from '@eagleview/ev-comp-library';
import { Trans } from 'lib/translation';
import { EVLink } from 'lib/components';
import Typography from 'commonComponents/typography';
import { Link } from 'lib/router';
import { SUPPORT_ROUTE } from 'constants/RouteConstants';
import { TERMS_US_USER, TERMS_CANADA_USER } from 'constants/AppConstants';
import ServiceAgreementStyles from './ServiceAgreementStyles';
import serviceAgreementPageDetails from './ServiceAgreement.utils';

function ServiceAgreement() {
  const classes = ServiceAgreementStyles();
  return (
    <EVPaper className={classes.serviceAgreementPaper}>
      <EVGrid container className={classes.deatilsContainer}>
        {serviceAgreementPageDetails.map((section) => (
          <EVGrid key={section.title}>
            <Typography variant="h1-400" fontColor="ocean-600">
              <Trans i18nKey={section.title} />
            </Typography>
            <Typography variant="body-400" fontColor="charcoal-900">
              <Trans
                i18nKey={section.info}
                components={{
                  link1: <EVLink style={{ color: '#007CAD' }} href={TERMS_US_USER}> Customer Service </EVLink>,
                  link2: <EVLink style={{ color: '#007CAD' }} href={TERMS_CANADA_USER}> Customer Service </EVLink>,
                }}
              />
            </Typography>
            {/* #genai: use optional chaining (Sonar S6582); section.sub is either an array or null/undefined, so semantics are unchanged */}
            {section.sub?.map((subSection) => (
              <EVGrid key={subSection.title}>
                <Typography variant="h2-400" fontColor="ocean-600">
                  <Trans i18nKey={subSection.title} />
                </Typography>
                <Typography variant="body-400" fontColor="charcoal-900">
                  <Trans
                    i18nKey={subSection.info}
                    components={{
                      a: (
                        <Link
                          style={{ color: '#007CAD', textDecoration: 'none' }}
                          to={SUPPORT_ROUTE}
                        >
                          customer service
                        </Link>
                      ),
                    }}
                  />
                </Typography>
              </EVGrid>
            ))}
          </EVGrid>
        ))}
      </EVGrid>
    </EVPaper>
  );
}

export default ServiceAgreement;
